import {
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import { ESTADO, TIPO_ENTIDAD } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';
import useFetch from 'http-react';
import { baseApi, token } from '../../services/Apis';

export const tipoEntidadEnums = [
  { id: 1, nombre: 'RESIDENCIA' },
  { id: 2, nombre: 'CLUB' },
  { id: 3, nombre: 'OFICINA' },
];

const TiposEntidadesField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  isSearch,
  disabled = false,
  isPublic = false,
}) => {
  const xName = 'Tipo de entidad';

  // const entitiTypes = isPublic
  //   ? [{ id: 4, nombre: 'CENTRO DE ENTRETENIMIENTO' }, { id: 5, nombre: 'RESTAURANTE' }]
  //   : tipoEntidadEnums;

  

  const { data: entityTypesData, loading: loadingEntityTypes } = useFetch(
    `${baseApi}/entity-types/short`,
    {
      headers: token({})
    }
  );

  const entitiTypes = (entityTypesData || []).filter((el) => isPublic ? ['restaurant', 'entertainmentCenter'].includes(el.name) : !['restaurant', 'entertainmentCenter'].includes(el.name)).map((el) => ({ id: el.id, nombre: el.label }));

  const xSearch = (
    <Autocomplete
      disablePortal
      id={ESTADO}
      options={entitiTypes}
      size="small"
      onChange={onChange}
      getOptionLabel={(option) => option.label}
      value={value}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          fullWidth
          label={xName}
          helperText={helperText ?? error ? validFielddHelper(1) : null}
          error={error}
          required={required ?? true}
          {...params}
        />
      )}
    />
  );

  const xSelect = (
    <FormControl
      fullWidth
      error={error}
      size="small"
      required
      disabled={disabled}
    >
      <InputLabel id={TIPO_ENTIDAD}>{xName}</InputLabel>
      <Select
        labelId={TIPO_ENTIDAD}
        id={TIPO_ENTIDAD}
        value={value}
        label={xName}
        onChange={onChange}
      >
        {entitiTypes.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.nombre}
            </MenuItem>
          );
        })}
      </Select>
      {error && (
        <FormHelperText>
          {helperText ?? error ? validFielddHelper(1) : null}
        </FormHelperText>
      )}
    </FormControl>
  );

  return isSearch ? xSearch : xSelect;
};

TiposEntidadesField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TiposEntidadesField;
